import { login } from "auth";
import { UserProfile } from "generated/graphql";
import React, { FC, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { State } from "redux/state";
import { UserMenu } from "../components/UserMenu";

export interface UserMenuContainerProps {

}

export const UserMenuContainer: FC<UserMenuContainerProps> = props => {

    const profile = useSelector<State, UserProfile>(state => state.auth.profile);

    const dispatch = useDispatch();

    const handleLogin = useCallback(() => {
        dispatch(login());
    }, []);

    return (
        <UserMenu profile={profile} login={handleLogin} />
    );
};

